import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import ProductEditionCard from 'Components/Product/ProductEditions/ProductEditionCard';
import useViewport from 'Hooks/useViewport';
import SiteSlider from 'Components/Utility/SiteSlider/SiteSlider';

import 'Components/Product/ProductEditions/ProductEditions.scss';

const ProductEditions = ({
  name,
  coverType,
  displayType,
  currentPageSlug,
  productEditions,
  presale,
}) => {
  const { isBelowMd } = useViewport();

  if (!currentPageSlug) return false;

  if (isEmpty(productEditions)) return false;

  const editions = productEditions.filter(productEdition => !isEmpty(productEdition.editionPoints));

  const cleanEditions = editions.filter(Boolean);

  if (isEmpty(cleanEditions)) return false;

  if (isBelowMd) cleanEditions.sort(e => (e.selected ? -1 : 1));

  const sliderSettings = {
    xs: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    sm: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    md: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    lg: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
    xl: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
    xxl: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
  };

  return (
    <section className="ProductEditions page-section-margin">
      <h2 className="section-title pb-2">
        <FormattedMessage id="producteditions.title" defaultMessage="{name} Editions" values={{ name: productEditions[0].name || name }} />
      </h2>

      <SiteSlider sliderClass="ProductCardCarousel" sliderSettings={sliderSettings}>
        {cleanEditions.map(edition =>
          <ProductEditionCard
            key={edition._id}
            presale={presale}
            coverType={coverType}
            displayType={displayType}
            edition={edition}
            currentPageSlug={currentPageSlug}
          />,
        )}
      </SiteSlider>
    </section>
  );
};


ProductEditions.propTypes = {
  name: PropTypes.string,
  coverType: PropTypes.string,
  displayType: PropTypes.string,
  currentPageSlug: PropTypes.string,
  productEditions: PropTypes.arrayOf(PropTypes.object),
  presale: PropTypes.bool,
};

ProductEditions.defaultProps = {
  name: '',
  editions: [],
  coverType: '',
  displayType: '',
  currentPageSlug: '',
  productEditions: [],
  presale: false,
};

export default ProductEditions;
